import React from "react";
import { useLang } from "../lib/LangContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="bg-[#0A0A0A] border-y border-white/10 overflow-hidden py-6">
      <div className="flex marquee-track whitespace-nowrap">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-12 px-6">
            <span className="font-display text-2xl sm:text-3xl text-[#D4AF37]/80">{item}</span>
            <span className="w-2 h-2 rotate-45 bg-[#E3000F]" />
          </div>
        ))}
      </div>
    </div>
  );
}
